<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openDialog(true)"
      >添加模板</el-button
    >
    <el-table :data="list" border size="small" style="width: 851px">
      <el-table-column prop="name" label="名称" align="center" width="300">
      </el-table-column>
      <el-table-column label="附件" align="center" width="300">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.props" :key="index">
            {{ attachments[item.id] }} x {{ item.amount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="250">
        <template slot-scope="scope">
          <el-button
            size="small"
            icon="el-icon-edit"
            @click="openDialog(false, scope.row)"
            >修改</el-button
          >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-delete"
            @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
  
  <script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      list: [],
      attachments: {},
    };
  },

  components: {},

  async created() {
    this.attachments = await this.$bizutil.loadAttachments(true);
    // 拉取邮件模板集合
    await this.loadList();
  },

  methods: {
    /**
     * 查询邮件模板集合
     */
    async loadList() {
      // 清空表格数据
      this.list = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryMailPropsTemplate`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let initlist = resData.data.list || [];

      for (let t of initlist) {
        t.props = JSON.parse(t.props);
        this.list.push(t);
      }
    },

    // 删除
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除附件：${entry.name}？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delMailPropsTemplate`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    async openDialog(isCreate, entry) {
      this.$dialogutil.open("EditMailPropsTemplateDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { isCreate: isCreate, entry: entry },
      });
    },
  },
};
</script>